import { graphql } from 'react-relay';
export const CollabDraftWithRelevanceQuery = graphql`
	query CollabDraftWithRelevanceQuery($id: ID!, $draftShareId: String = "", $hydrateAdf: Boolean) {
		collabDraft(id: $id, draftShareId: $draftShareId, hydrateAdf: $hydrateAdf) {
			document
			version
			metadata {
				title
				relevance
			}
		}
	}
`;
